import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { filter, shareReplay, switchMap } from 'rxjs/operators';
import { EthWalletService } from './eth-wallet.service';
import { Network } from './configuration';

(window as any)['BigNumber'] = require('bignumber.js');

export interface Instances {
  readonlyInstance: Observable<any>;
  instance: Observable<any>;
  setReadonlytNetwork: (network: Network) => void
}

@Injectable({
  providedIn: 'root'
})
export class ContractService {
  private contracts: Map<string, Instances> = new Map();

  constructor(
    public ethWalletService: EthWalletService
  ) {
  }

  getInstances(address: string, abi: any): Instances {
    if (!this.contracts.has(address)) {
      const instance = this.ethWalletService.web3.pipe(
        filter(i => !!i),
        switchMap(() => this.ethWalletService.contractAt(address, abi)),
        shareReplay(1)
      );
      const subject = new BehaviorSubject(null);
      const readonlyInstance = subject.pipe(
        switchMap((network) => {
          if (network) {
            return of(this.ethWalletService.contractAtByWeb3(address, abi, this.ethWalletService.getReadonlyWeb3(network)));
          } else {
            return this.ethWalletService.contractAt(address, abi, true);
          }
        }),
        shareReplay(1)
      );
      this.contracts.set(address, {
        readonlyInstance,
        instance: instance,
        setReadonlytNetwork: (network: Network) => subject.next(network)
      });
      instance.subscribe(a => (window as any)['C_' + address] = a);
    }
    return this.contracts.get(address);
  }
}
